import React from 'react';
import styled from '@emotion/styled';
import type { ItemDetail } from 'src/types/itemInventory';
import Category from './Category';
import ItemRow from './ItemRow';
interface Props {
  items: ItemDetail[];
}
const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const PeriodicPurchase: React.FC<Props> = ({
  items
}) => {
  return <Category title='inventory_unlimited_item_title' description='inventory_unlimited_item_desc' data-sentry-element="Category" data-sentry-component="PeriodicPurchase" data-sentry-source-file="PeriodicPurchase.tsx">
      <ItemList data-sentry-element="ItemList" data-sentry-source-file="PeriodicPurchase.tsx">
        {items.map(item => <ItemRow key={`periodic-${item.inventoryId}`} item={item} />)}
      </ItemList>
    </Category>;
};
export default PeriodicPurchase;